import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/salesCopy';
export function TestimonialWall() {
  const [featured, ...rest] = testimonials;
  return <section className="w-full bg-night" data-id="element-242" data-mp="3itvfnteg27xe">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-243" data-mp="3isu5dr595pgq">
        <div className="text-center" data-id="element-244" data-mp="3mufbmtna75hy">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-245" data-mp="3mte2wvtqmv3e">
            Trusted by guitar teachers
          </p>
          <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-246" data-mp="3dvbtbrvxuu4i">
            What teachers <span className="text-gold" data-id="element-247" data-mp="2zwu5zv9y3jn4">are saying</span>
          </h2>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 sm:gap-5 lg:grid-cols-3" data-id="element-248" data-mp="33wmjmme74fzc">
          <figure className="flex h-full flex-col rounded-2xl border border-gold/40 bg-panel-soft p-6 sm:p-8 lg:row-span-2" data-id="element-249" data-mp="y3wbzw4fml0l">
            <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-250" data-mp="122nb28sgkcqc">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-251" data-mp="1roidah34xp9w" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 font-serif text-lg italic leading-snug text-cream sm:mt-5 sm:text-2xl" data-id="element-252" data-mp="26d4r2ed468z0">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6 sm:pt-8" data-id="element-253" data-mp="1do7mfe1tsaoq">
              {featured.photo ? <img src={featured.photo} alt="" className="h-12 w-12 shrink-0 rounded-full border border-gold/40 object-cover" data-id="element-254" data-mp="18pmh507pv0tf" /> : <span aria-hidden="true" className="flex h-12 w-12 items-center justify-center rounded-full bg-gold text-xs font-semibold text-night" data-id="element-255" data-mp="1im95w035yc0q">
                  {featured.initials}
                </span>}
              <span className="text-sm" data-id="element-256" data-mp="3165o9q85knu9">
                <span className="block font-semibold text-cream" data-id="element-257" data-mp="315e193smfyfl">{featured.name}</span>
                <span className="block text-cream-muted" data-id="element-258" data-mp="3635r7s9phah5">{featured.role}</span>
              </span>
            </figcaption>
          </figure>

          {rest.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-line bg-panel p-5 sm:p-6" data-id="element-259" data-mp="3g36flsmfmgs7">
              <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-260" data-mp="2ne8vrl2kobxc">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-261" data-mp="2scarb5h6q3pp" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[15px] leading-relaxed text-cream-muted" data-id="element-262" data-mp="2x5lo0dsa943w">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-263" data-mp="24nrf4ev0l6sc">
                {item.photo ? <img src={item.photo} alt="" className="h-11 w-11 shrink-0 rounded-full border border-line object-cover" data-id="element-264" data-mp="lt54ydsd99no" /> : <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/40 text-xs font-semibold text-gold" data-id="element-265" data-mp="cqvxjwse9wei">
                    {item.initials}
                  </span>}
                <span className="text-sm" data-id="element-266" data-mp="3u6vm3hznnfnc">
                  <span className="block font-semibold text-cream" data-id="element-267" data-mp="3q6uxj4iudo2k">{item.name}</span>
                  <span className="block text-cream-muted" data-id="element-268" data-mp="3q4h3myzwehwl">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}